import React, { Component } from "react"
import { Link } from "react-router-dom"
import "./Welcome.css"

/**
 * A body of text and single accept button that triggers a callback.
 *
 * @class      Welcome (name)
 */
class Welcome extends Component {
  render() {
    return (
      <div>
        <div className="WelcomeText">
          <p>
            An occult theory purports that the physical rainwater actually
            contains the experience it evokes.
          </p>
          <p>
            We have been walking in the rain. It is an extremely contemplative,
            all-encompassing experience. We wrote about it in a text called the
            Rain Diaries. Afterwards, we bottled some of the rain, consumed
            drops of it and wrote about that. But what we really want to do is
            to talk about rain in the language of rain. For that, we have built
            a water installation to replicate our experience without words,
            uttering only circles in water.
          </p>
          <p>
            This web site is dual to physical book and installation{" "}
            <a href="http://www.myymala2.com/?page_id=4808">
              presented in Myymälä2
            </a>{" "}
            in April 2019 and{" "}
            <a href="https://kersnikova.org/">
              Modul gallery of Kersnikova Instutute
            </a>{" "}
            in November 2019 and otherwise documented{" "}
            <a href="https://oturpe.kapsi.fi/projects/device/2019/03/28/As_above_so_below.html">
              here
            </a>
            .
          </p>
          <p>
            Copies of the <a href="print.png">printed edition</a> can be
            purchased for 25 € + postage. Payment through IBAN money transfer or
            as agreed. Contact{" "}
            <a href="mailto:ana.mrovlje@gmail.com?subject=Rain%20Diaries%20purchase&body=I%20would%20like%20to%20purchase%20a%20printed%20copy%20of%20the%20Rain%20Diaries.%20Delivery%20to%20(INSERT%20DELIVERY%20ADDRESS).%20Please%20let%20me%20know%20your%20IBAN%20and%20total%20sum%20including%20postage%20for%20payment.">
              ana.mrovlje@gmail.com
            </a>{" "}
            for details.
          </p>
          <p>
            Otto Urpelainen
            <br />
            Ana Mrovlje
          </p>
          <div style={{ "text-align": "center" }}>
            <Link class="InteractionBlock TextLink" to="/diaries">
              Enter
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default Welcome



// WEBPACK FOOTER //
// ./src/pages/Welcome.js